// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalLoginController = function ($scope, $rootScope, $routeParams, $http, $location, AccountLogout) {
    if ($rootScope.accessToken) {
        AccountLogout.logout();
    }

    $scope.THIRD_PARTY_INTEGRATION = Object.freeze({
        'Atriga': 'Atriga',
        'Epay': 'Epay',
        'AzureActiveDirectory': 'AzureActiveDirectory',
        'OpenIdConnect': 'OpenIdConnect'
    });

    $scope.dto = {};
    $scope.features = [];

    function validateLoginRequest() {
        $http({
            method: "POST", url: "api/v1/features/" + $routeParams.entityId + "/validate",
            data: [ $scope.THIRD_PARTY_INTEGRATION.OpenIdConnect, $scope.THIRD_PARTY_INTEGRATION.AzureActiveDirectory ],
            cache: false
        }).then(function (response) {
            $scope.features = response.data;
        }).then(function (){
            $http({
                method: "GET", url: "externalLogin/" + $routeParams.entityId + "/loginConfiguration",
                cache: false
            }).then(function (response) {
                if (response.data.SkipLoginPage === true) {
                    $scope.login(response.data.ActiveExternalProviderAuthenticationIntegration);
                }
            });
        });
    }
    
    validateLoginRequest();

    $scope.login = function (provider) {
        $http({
            method: "GET", url: "externalLogin/Challenge",
            params: {
                provider: provider,
                entityId: $routeParams.entityId,
                clientId: "515eb5767b740c6a51b18a70"
            },
            data: $scope.settings,
            cache: false
        }).then(function (redirectUrl) {
            window.location = redirectUrl.data;
        });
    };
};

ExternalLoginController.$inject = ["$scope", '$rootScope', '$routeParams', '$http', '$location', 'AccountLogout'];
